<script setup>
import {ref, computed, watch} from 'vue'
import {useItemDataStore} from '@/stores/itemData'
import {useFormStore} from '@/stores/form'
import FormSidebarBtn from "@/common/form/FormSidebarBtn.vue"

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    isInvoice: {
        type: Boolean,
        default: false
    }
})

// Pinia Stores
const itemDataStore = useItemDataStore()
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// --- State ---
const order = ref({})

// --- Computed ---
const tableName = computed(() => formStore.value?.tableName)
const id = computed(() => formStore.value?.id)

const show = computed(() => tableName.value === 'm_basket_orders')
const text = computed(() => props.isInvoice ? 'Print invoice' : 'Print delivery')

watch(() => [show.value, id.value], async ([shouldShow, currentId]) => {
    if (shouldShow && currentId) {
        order.value = await itemDataStore.get({
            tableName: 'm_basket_orders',
            id: currentId
        })
    } else {
        order.value = {}
    }
}, {immediate: true})

// --- Methods ---
const printInvoice = () => {
    // If it's an invoice, deliveryBool is 0. If it's delivery note, deliveryBool is 1.
    const deliveryBool = props.isInvoice ? 0 : 1
    const url = `print-invoice.html#/?orderId=${order.value.id}&delivery=${deliveryBool}`

    window.open(url)
}
</script>

<template>
    <FormSidebarBtn
        v-if="show"
        :disabled="order.gatewayId === 0"
        @click.prevent="printInvoice"
    >
        <i class="me-2 bi-printer"/>
        {{ text }}
    </FormSidebarBtn>
</template>

<style scoped>
button:disabled {
    background: none;
}
</style>